import { CircularProgress } from "@mui/material";
import React from "react";

export const PageLoader = ({
  height,
  wrapperHeight,
  wrapperStyles,
  wrapperWidth,
  color,
}) => {
  return (
    <div
      className="page-loader"
      style={
        wrapperStyles
          ? wrapperStyles
          : { height: wrapperHeight || "100vh", width: wrapperWidth }
      }
    >
      <div className="page-loader-box" style={height ? { height: height } : {}}>
        <CircularProgress
          style={{
            width: "100px",
            height: "100px",
            color: color ? color : "#88C3E1",
          }}
        />
      </div>
    </div>
  );
};
